import { isEmpty as lodashEmpty } from 'lodash';

/**
 * Проверяет, не является ли переданная переменная пустой.
 * Возвращает true, если переменная не пуста, иначе false.
 *
 * @template T - Ожидаемый тип переменной.
 * @param {unknown} variable - Переменная для проверки.
 * @returns {variable is T} true, если переменная не пуста.
 */
export const isNotEmpty = <T>(variable: unknown): variable is T =>
  !lodashEmpty(variable);
